import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"


import SpacedRow from '@shell/components/Resource/Detail/SpacedRow.vue';
import ExtrasCard from '@shell/components/Resource/Detail/Card/ExtrasCard.vue';
import { computed } from 'vue';

export interface Props {
  resource: any;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'Cards',
  props: {
    resource: {}
  },
  setup(__props: any) {


const cards = computed(() => __props.resource?.cards?.filter((c: any) => c) || []);
const showExtrasCard = computed(() => cards.value.length >= 1 && cards.value.length < 3);

return (_ctx: any,_cache: any) => {
  return (cards.value.length > 0)
    ? (_openBlock(), _createBlock(SpacedRow, { key: 0 }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cards.value, (card, i) => {
            return (_openBlock(), _createBlock(_resolveDynamicComponent(card.component), _mergeProps({ key: i }, { ref_for: true }, card.props), null, 16))
          }), 128)),
          _cache[0] || (_cache[0] = _createTextVNode()),
          (showExtrasCard.value)
            ? (_openBlock(), _createBlock(ExtrasCard, { key: 0 }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})